// Week 2 / Day 2 — Check First Rule (Social Safety).
// Reworked: bilingual RU/EN inline; calm, empowering tone.
// 50% online + 50% paper/parent. Five layers preserved.
// SAFETY: behaviour-based judging (not appearance); paper role-play only; no PII.

const day2 = {
  id: 'day-2',
  studentId: 'max',
  weekId: 'week-2',
  dayId: 'day-2',
  status: 'active',
  title: 'Правило «Проверить сначала» / Check First Rule',
  shortTitle: 'Проверить сначала / Check First',
  theme:
    'Перед тем как идти, помогать, принимать подарок или садиться в машину, нужно проверить с доверенным взрослым. / Before going somewhere, helping someone, accepting something or getting into a car, check with a trusted adult.',
  estimatedTimeLabel:
    'Онлайн-миссия: около 20–30 минут. Бумажная миссия с родителем: около 25–35 минут. / Online mission: about 20–30 minutes. Paper mission with parent: about 25–35 minutes.',
  nimnyIntro:
    'Нимни нашла вторую часть Щита безопасности. На ней написано: «Проверить сначала». Помоги Нимни выбрать безопасное действие в странных ситуациях. / Nimny found the second part of the Safety Shield. It says: "Check First". Help Nimny choose safe actions in strange situations.',
  goals: [
    'Слой 1. Математика: дроби карточек (зелёные, жёлтые, красные), время шагов, простые таблицы. / Layer 1. Math: card fractions (green/yellow/red), step time, simple tables.',
    'Слой 2. Русский язык и правописание: словарь правила, мини-диктант, исправление. / Layer 2. Russian language and spelling: rule vocabulary, mini-dictation, correction.',
    'Слой 3. Чтение, письмо и пересказ: «Почему нужно проверять сначала?» — план, пересказ и 3–5 предложений. / Layer 3. Reading, writing and retelling: "Why should we check first?" — plan, retell and 3–5 sentences.',
    'Слой 4. Наблюдение и логика — зелёный, жёлтый, красный. / Layer 4. Observation and Logic — Green, Yellow, Red.',
    'Слой 5. Практика на бумаге: «Лестница действий Нимни» (5 шагов) и сортировка карточек. / Layer 5. Paper practice: "Nimny\'s Action Ladder" (5 steps) and card sorting.',
    'Дневник мышления: одна уверенная фраза безопасности. / Thinking diary: one confident safety phrase.',
    'Награда нимами: базово 3 нима, максимум 5 с бонусами. / Reward in nims: 3 base, up to 5 with bonuses.'
  ],
  vocabulary: [
    { term: 'незнакомый / unfamiliar person', definition: 'тот, кого мы не знаем и кого не одобрил родитель. / someone we do not know and who is not parent-approved.' },
    { term: 'проверить / check', definition: 'спросить у доверенного взрослого. / ask a trusted adult.' },
    { term: 'сначала / first', definition: 'до того, как идти или принимать. / before going or accepting.' },
    { term: 'подарок / gift', definition: 'то, что предлагают вне дома. / something offered outside the home.' },
    { term: 'машина / car', definition: 'не сажусь в чужую машину без родителя. / I do not get into a stranger\'s car without a parent.' },
    { term: 'идти / go', definition: 'не иду без проверки. / I do not go without checking.' },
    { term: 'нельзя / not allowed', definition: 'когда правило говорит «нет». / when the rule says "no".' },
    { term: 'секрет / secret', definition: 'если кто-то просит «не говори родителям» — это сигнал тревоги. / if someone says "do not tell your parents" — that is a warning.' },
    { term: 'правило / rule', definition: 'короткое чёткое действие. / a short clear action.' },
    { term: 'взрослый / adult', definition: 'доверенный взрослый, к которому я обращаюсь. / a trusted adult I turn to.' }
  ],
  onlineTasks: [
    {
      id: 'q1',
      type: 'math',
      title: 'Светофор ситуаций / Situation traffic light',
      prompt:
        'Что сделать / What to do: найди число красных карточек.\nЕсть 48 карточек ситуаций. 3/8 карточек зелёные, 1/3 — жёлтые, остальные — красные. Сколько красных карточек?\nThere are 48 situation cards. 3/8 are green, 1/3 are yellow, and the rest are red. How many red cards are there?',
      helper: 'Найди две дробные части от 48, потом вычти их сумму из общего. / Find two fractional parts of 48, then subtract their sum from the total.',
      answer: '14',
      unit: 'красных карточек / red cards'
    },
    {
      id: 'q2',
      type: 'math',
      title: 'Время спокойной проверки / Calm check time',
      prompt:
        'Что сделать / What to do: посчитай общее время в минутах.\nЧтобы проверить ситуацию, Нимни делает 3 шага: остановиться — 0.5 минуты, найти взрослого — 1.75 минуты, объяснить ситуацию — 2.25 минуты. Сколько минут занимает весь план?\nTo check a situation, Nimny uses 3 steps: stop — 0.5 minutes, find an adult — 1.75 minutes, explain the situation — 2.25 minutes. How many minutes does the whole plan take?',
      helper: 'Сложи десятичные числа по столбику. Можешь сгруппировать четверти. / Add the decimals; you may group quarters and halves.',
      answer: '4.5',
      unit: 'минут / minutes'
    },
    {
      id: 'q3',
      type: 'math',
      title: 'Фразы проверки / Check phrases',
      prompt:
        'Что сделать / What to do: найди, сколько фраз в одном наборе.\nНимни записала 3 одинаковых набора фраз и ещё 12 карточек с примерами. Всего получилось 57 карточек. Сколько фраз было в одном наборе?\nNimny wrote 3 equal sets of phrases and 12 example cards. In total, there were 57 cards. How many phrases were in one set?',
      helper: 'Это уравнение: вычти дополнительные карточки, потом раздели остаток на число наборов. / Equation: subtract the extras, then divide by the number of sets.',
      answer: '15',
      unit: 'фраз в наборе / phrases per set'
    },
    {
      id: 'q4',
      type: 'math',
      title: 'После тренировки / After practice',
      prompt:
        'Что сделать / What to do: найди итоговое число учеников.\nВ школе 120 учеников. 65% уже знают правило «Check first». После тренировки ещё 18 учеников выучили правило. Сколько учеников теперь знают правило?\nThere are 120 students. 65% already know the "Check first" rule. After practice, 18 more students learned it. How many students know it now?',
      helper: 'Сначала процент от числа (0.65 × 120), потом прибавь новых. / First find the percent of the total, then add the new ones.',
      answer: '96',
      unit: 'учеников / students'
    },
    {
      id: 'q5',
      type: 'classify',
      title: 'Слова правила — парные согласные / Rule words — paired consonants',
      prompt:
        'Какая парная согласная пишется в корне? Используй проверочное слово. / Which paired consonant is in the root? Use a check word.',
      categories: [
        { id: 'voiced', label: 'звонкая / voiced' },
        { id: 'voiceless', label: 'глухая / voiceless' }
      ],
      items: [
        { id: 'podarok', text: 'подарок — проверка: подарочек / "podarok" — check: подарочек' },
        { id: 'mashina', text: 'машина — проверка: машинка / "mashina" — check: машинка' },
        { id: 'sled', text: 'след — проверка: следы / "sled" — check: следы' },
        { id: 'gladko', text: 'гладко — проверка: гладок / "gladko" — check: гладок' },
        { id: 'nelzia', text: 'нельзя — нет парной (запомнить) / "nelzia" — no pair (memorise)' },
        { id: 'pravilo', text: 'правило — проверка: правил / "pravilo" — check: правил' }
      ]
    },
    {
      id: 'q6',
      type: 'text',
      title: 'Мини-диктант / Mini-dictation',
      prompt:
        'Запиши без ошибок: «Сначала проверь с родителем. Если просьба кажется странной, отойди и найди безопасного взрослого.» / Write without mistakes: "Check with a parent first. If a request feels strange, move away and find a safe adult."',
      placeholder:
        'Сначала проверь ... / Check first ...'
    },
    {
      id: 'q_corr',
      type: 'text',
      title: 'Исправь ошибки / Correct the mistakes',
      prompt:
        'Перепиши без ошибок: «снечала проверь с родитилим. еслi просьба кажется страной, аатойди и найди безапасного взрослого.» Подсказки: безударные гласные проверяй ударением; парные согласные — гласной (отойди → отойти/отойдём); удвоенных букв нет в «отойди». / Rewrite: "снечала проверь с родитилим. еслi просьба кажется страной, аатойди и найди безапасного взрослого." Hint: unstressed vowels checked by stressed form; «странной» — две «н»; capital letters and periods.',
      placeholder:
        'Сначала проверь с родителем. Если просьба кажется странной, отойди и найди безопасного взрослого. / Check first with a parent. ...'
    },
    {
      id: 'q7',
      type: 'text',
      title: 'План текста и письмо / Text plan and writing',
      prompt:
        'Прочитай короткий текст: «Взрослый не должен звать ребёнка уйти, не проверив с родителем. Подарок, поездка или секрет от родителей — это сигналы «жёлтый» или «красный». Ребёнок может сказать нет, отойти и найти безопасного взрослого.» Запиши план из 3 пунктов и 3–5 предложений на русском по теме: «Что я скажу, если мне нужно проверить сначала?» / Read the short text: "An adult should not invite a child away without checking with a parent. A gift, a ride, or a secret from parents are yellow or red signals. A child can say no, move away, and find a safe adult." Write a 3-point plan and 3–5 Russian sentences on: "What will I say if I need to check first?"',
      placeholder:
        '1. ... 2. ... 3. ... Мои предложения: ... / 1. ... 2. ... 3. ... My sentences: ...'
    },
    {
      id: 'q_obs',
      type: 'text',
      title: 'Наблюдение и логика — зелёный, жёлтый, красный / Observation and Logic — Green, Yellow, Red',
      prompt:
        'Реши коротко:\nЗелёный = ____ (одобрено родителем, спокойная просьба)\nЖёлтый = ____ (надо проверить сначала)\nКрасный = ____ (стоп и сразу к взрослому)\nЧто меняется, если просьба содержит «секрет от родителей»? Что важнее: внешность взрослого или его просьба? Сделай вывод одной фразой. / Define green / yellow / red briefly. What changes with "secret from parents"? Appearance or request? One-line conclusion.',
      placeholder:
        'Зелёный: ... Жёлтый: ... Красный: ... При секрете: ... Главное — ... Вывод: ... / Green: ... Yellow: ... Red: ... With secret: ... What matters: ... Conclusion: ...'
    },
    {
      id: 'q8',
      type: 'classify',
      title: 'Зелёный, жёлтый, красный / Green, Yellow, Red',
      prompt:
        'Распредели карточки ситуаций по корзинам действий. / Sort the situation cards into action baskets.',
      categories: [
        { id: 'green', label: 'Зелёный — можно / Green — okay' },
        { id: 'yellow', label: 'Жёлтый — проверить сначала / Yellow — check first' },
        { id: 'red', label: 'Красный — стоп и к взрослому / Red — stop and tell an adult' }
      ],
      items: [
        { id: 'parentteacher', text: 'родитель сказал идти с учителем / parent said to go with the teacher' },
        { id: 'rideunknown', text: 'незнакомый взрослый зовёт в машину / an unknown adult invites into a car' },
        { id: 'giftnoparent', text: 'кто-то предлагает подарок без родителя / someone offers a gift without a parent' },
        { id: 'helpfind', text: 'взрослый просит ребёнка помочь найти животное / an adult asks the child for help finding an animal' },
        { id: 'friendplay', text: 'друг зовёт на площадку, родитель не знает / a friend invites to a playground; parent does not know' },
        { id: 'secretparents', text: 'человек говорит: «это секрет от родителей» / someone says "this is a secret from your parents"' },
        { id: 'teacherasks', text: 'учитель просит идти в офис школы / a teacher asks to go to the school office' },
        { id: 'onlineperson', text: 'сообщение онлайн просит личные данные / an online message asks for personal data' }
      ]
    },
    {
      id: 'q9',
      type: 'essay',
      title: 'Дневник мышления: моя уверенная фраза / Thinking diary: my confident phrase',
      prompt:
        'Напиши 3–5 предложений: какая уверенная фраза поможет проверить сначала и кому я её скажу. На английском добавь одну фразу: "I need to check with my parent" или "No, I can\'t go". Используй слова: проверить, сначала, взрослый, правило. / Write 3–5 sentences: which confident phrase helps me check first and to whom. Add one English phrase. Use words: check, first, adult, rule.',
      minSentences: 3,
      maxSentences: 5,
      placeholder:
        'Моя уверенная фраза ... / My confident phrase ...'
    }
  ],
  notebookInstructions: [
    'Заголовок: «Неделя 2, День 2 — Проверить сначала». / Heading: "Week 2, Day 2 — Check First".',
    'Слой 1. Математика: реши q1–q4 и нарисуй полосу карточек: 6 зелёных, 5 жёлтых, 4 красных. / Layer 1. Math: solve q1–q4 and draw the card bar: 6 green, 5 yellow, 4 red.',
    'Слой 2. Русский язык: запиши словарь правила и мини-диктант. / Layer 2. Russian: write the rule vocabulary and the mini-dictation.',
    'Слой 3. Чтение и пересказ: 3-пунктовый план + 3–5 предложений; перескажи родителю. / Layer 3. Reading and retelling: 3-point plan + 3–5 sentences; retell to a parent.',
    'Слой 4. Наблюдение и логика: запиши, чем отличается зелёная карточка от жёлтой и красной. / Layer 4. Observation and Logic: write how a green card differs from a yellow and a red card.',
    'Слой 5. Практика: запиши 5 шагов лестницы действий и одну фразу на английском. / Layer 5. Practice: write the 5 action steps and one English phrase.',
    'Дневник мышления: одна уверенная фраза безопасности. / Thinking diary: one confident safety phrase.',
    'Награда нимами начисляется после проверки родителем. / Reward in nims is added after a parent check.'
  ],
  printWorksheet: {
    title: 'Неделя 2, День 2 / Week 2, Day 2',
    subtitle: 'Лестница действий Нимни / Nimny\'s Action Ladder',
    pages: [
      {
        title: 'Маршрут миссии — Проверить сначала / Mission Route — Check First',
        blocks: [
          { type: 'text', text: 'Сегодня — пять слоёв и одна миссия. Отмечай ☐ → ☑. / Today — five layers and one mission. Mark ☐ → ☑.' },
          { type: 'list', items: [
            '☐ Слой 1. Математика — около 10 минут. / Layer 1. Math — about 10 minutes.',
            '☐ Слой 2. Русский язык — около 10 минут. / Layer 2. Russian — about 10 minutes.',
            '☐ Слой 3. Чтение и пересказ — около 10 минут. / Layer 3. Reading and retelling — about 10 minutes.',
            '☐ Слой 4. Наблюдение и логика — около 5 минут. / Layer 4. Observation and Logic — about 5 minutes.',
            '☐ Слой 5. Практика на бумаге — около 15 минут. / Layer 5. Paper practice — about 15 minutes.',
            '☐ Дневник мышления — 5 минут. / Thinking diary — 5 minutes.',
            '☐ Печать миссии и награда нимами. / Mission stamp and nim reward.'
          ]}
        ]
      },
      {
        title: 'Слой 1. Математика — правило «Проверить сначала» в числах / Layer 1. Math — "Check First" in Numbers',
        blocks: [
          { type: 'text', text: 'Математика уровня 5–6 класса. Запиши решение по шагам и финальный ответ. / Grade 5–6 math. Show steps and the final answer.' },
          { type: 'list', items: [
            '1) 48 карточек: 3/8 зелёных, 1/3 жёлтых, остальные красные. Сколько красных? Ответ: ____ / 48 cards: 3/8 green, 1/3 yellow, rest red. Answer: ____',
            '   Шаги / Steps: __________________________________________',
            '2) План проверки: 0.5 + 1.75 + 2.25 минуты. Сколько всего минут? Ответ: ____ минуты / 0.5 + 1.75 + 2.25 = ?',
            '   Шаги / Steps: __________________________________________',
            '3) 3 одинаковых набора фраз + 12 примеров = 57 карточек. Сколько фраз в одном наборе? Ответ: ____ / 3 sets + 12 extras = 57. Per set?',
            '   Шаги / Steps: __________________________________________',
            '4) 120 учеников: 65% знают правило + 18 ещё выучили. Сколько теперь знают? Ответ: ____ учеников / 120 students, 65% + 18 more. Answer: ____',
            '   Шаги / Steps: __________________________________________'
          ]}
        ]
      },
      {
        title: 'Слой 2. Русский язык и правописание — слова правила / Layer 2. Russian Language and Spelling — Rule Words',
        blocks: [
          { type: 'text', text: 'Правило дня: парные согласные в корне проверяем гласной. / Rule of the day: paired consonants in the root are checked with a vowel.' },
          { type: 'list', items: [
            'Словарь миссии: незнакомый, проверить, сначала, подарок, машина, идти, нельзя, секрет, правило, взрослый. / Mission vocabulary.',
            'Мини-диктант: «Сначала проверь с родителем. Если просьба кажется странной, отойди и найди безопасного взрослого.» / Mini-dictation.',
            'Запиши без ошибок: __________________________________________ / Write without mistakes:',
            'Исправление: «снечала проверь с родитилим. еслi просьба кажется страной, аатойди и найди безапасного взрослого.» / Correct and rewrite the sentence with mistakes.',
            'Подчеркни парные согласные: подарок, след, гладко, правило. / Underline paired consonants.'
          ]}
        ]
      },
      {
        title: 'Слой 3. Чтение, письмо и пересказ — почему проверять сначала / Layer 3. Reading, Writing and Retelling — Why Check First',
        blocks: [
          { type: 'text', text: 'Прочитай короткий текст и сделай план. / Read the short text and make a plan.' },
          { type: 'list', items: [
            'Текст: «Взрослый не должен звать ребёнка уйти, не проверив с родителем. Подарок, поездка или секрет от родителей — это сигналы «жёлтый» или «красный». Ребёнок может сказать нет, отойти и найти безопасного взрослого.» / Text: "An adult should not invite a child away..."',
            'План: 1) ____________________  2) ____________________  3) ____________________ / Plan',
            'Главная мысль: ______________________________________ / Main idea',
            'Мои 3–5 предложений «Что я скажу, если мне нужно проверить сначала?»: / My 3–5 sentences',
            '1. ______________________________________________',
            '2. ______________________________________________',
            '3. ______________________________________________',
            '☐ Я пересказал родителю / I retold a parent.'
          ]}
        ]
      },
      {
        title: 'Слой 4. Наблюдение и логика — зелёный, жёлтый, красный / Layer 4. Observation and Logic — Green, Yellow, Red',
        blocks: [
          { type: 'text', text: 'Понаблюдай: цвет зависит от ситуации, а не от внешности. / Observe: the colour depends on the situation, not on appearance.' },
          { type: 'list', items: [
            'Зелёный = что? ____________________ / Green = what?',
            'Жёлтый = что? ____________________ / Yellow = what?',
            'Красный = что? ____________________ / Red = what?',
            'Что меняется, если просьба содержит «секрет от родителей»? ____________________ / What changes if a request includes "secret from parents"?',
            'Что важнее: внешность взрослого или его просьба? ____________________ / What matters more: appearance or the request?',
            'Мой вывод (1 фраза): ____________________ / My conclusion (1 line):'
          ]}
        ]
      },
      {
        title: 'Слой 5. Практика на бумаге — Лестница действий / Layer 5. Paper Practice — Action Ladder',
        blocks: [
          { type: 'text', text: 'Запиши 5 шагов и потренируйся вслух с родителем. / Write 5 steps and practise aloud with a parent.' },
          { type: 'list', items: [
            '1) Остановись. / Stop.',
            '2) Отойди. / Move away.',
            '3) Скажи: «I need to check with my parent.» / Say: "I need to check with my parent."',
            '4) Найди безопасного взрослого. / Find a safe adult.',
            '5) Расскажи родителю. / Tell your parent.',
            '[Нарисуй здесь щит Нимни с лестницей действий] / [Draw the Nimny Shield with the Action Ladder]',
            'Карточки сортировки: «Можно», «Проверить сначала», «Стоп и к взрослому». / Sorting baskets.',
            '☐ Обведи 1 «можно». / Circle 1 "okay".',
            '☐ Обведи 1 «проверить сначала». / Circle 1 "check first".',
            '☐ Обведи 1 «стоп и к взрослому» красным. / Circle 1 "stop and tell" in red.',
            'Английские фразы (потренируйся вслух): / English phrases (practise aloud):',
            '☐ "I need to check with my parent."',
            '☐ "No, I can\'t go."',
            '☐ "I need an adult."',
            '☐ "Please call my parent."',
            '☐ "I don\'t know you."',
            'Ролевая игра с родителем: 1–2 минуты. / Role-play with a parent: 1–2 minutes.',
            '[Поставь печать миссии] / [Place mission stamp]'
          ]}
        ]
      },
      {
        title: 'Дневник мышления / Thinking Diary',
        blocks: [
          { type: 'list', items: [
            'Моя уверенная фраза безопасности: ______________________ / My confident safety phrase',
            'Я выбрал её, потому что _________________________ / I chose it because',
            'Слово миссии, которое запомнилось: ________________ / Mission word I remember'
          ]}
        ]
      },
      {
        title: 'Родительская проверка и награда нимами / Parent Check and Nim Reward',
        blocks: [
          { type: 'text', text: 'После проверки начисли бонусные нимы через Parent Room. / After checking, add bonus nims through Parent Room.' },
          { type: 'list', items: [
            'Базовая награда: 3 нима ☐ / Base reward: 3 nims ☐',
            'Бонус за правильное правило «проверить сначала»: +1 ☐ / Check-first-rule bonus: +1 ☐',
            'Бонус за уверенную фразу безопасности: +1 ☐ / Safety-phrase bonus: +1 ☐',
            'Итого: ____ из 5 нимов. / Total ____ of 5 nims.',
            'Печать миссии (родитель): ☐ / Mission stamp (parent): ☐',
            'Подпись родителя: ____________________ / Parent signature'
          ]}
        ]
      }
    ]
  },
  parentGuide: {
    goal:
      'Ребёнок учится правилу «Проверить сначала» и тренирует короткие уверенные фразы (русский + английский) для странных ситуаций. Без страха, но уверенно. / The child learns the "Check First" rule and practises short confident phrases (RU + EN) for strange situations. Calm and confident, not scary.',
    mathGoal:
      'Уровень 5–6 класса: дроби от числа (3/8 × 48, 1/3 × 48); сложение десятичных (0.5 + 1.75 + 2.25); линейное уравнение 3x + 12 = 57; процент от числа (65% × 120). / Grade 5–6: fractions of a number; decimal addition; linear equation; percent of a number.',
    russianGoal:
      'Парные согласные в корне; правильно записанный мини-диктант; исправлены 3–5 коротких предложений. / Paired consonants; correct mini-dictation; 3–5 sentences corrected.',
    readingWritingGoal:
      'План из 3 пунктов; пересказ родителю; 3–5 предложений на русском по теме «что скажу, если нужно проверить сначала». / 3-point plan; retell; 3–5 Russian sentences on what to say.',
    observationLogicGoal:
      'Ребёнок различает зелёный/жёлтый/красный по поведению и просьбе, а не по внешности. / Child distinguishes green/yellow/red by behaviour and request, not by appearance.',
    practicalGoal:
      'Записаны 5 шагов лестницы действий; разложены карточки по 3 корзинам; названа фраза на русском и одна на английском; родитель и ребёнок проиграли 1 короткую сценку. / 5 ladder steps written; cards sorted into 3 baskets; one RU phrase + one EN phrase; one short role-play done.',
    check: [
      'Q1: 14 (48 − (18+16)). Q2: 4.5 (0.5+1.75+2.25). Q3: 15 (3x+12=57). Q4: 96 (78+18). / Math answers.',
      'Мини-диктант записан без грубых ошибок. / Mini-dictation OK.',
      'План текста — 3 пункта; пересказ — 3–5 предложений по-русски. / Plan = 3 points; retell = 3–5 sentences.',
      'Карточки разложены по «зелёный / жёлтый / красный» логично. / Cards sorted into green / yellow / red.',
      'Лестница действий из 5 шагов записана; одна английская фраза проговорена вслух. / 5-step ladder written; 1 EN phrase spoken.',
      'Дневник мышления заполнен. / Thinking diary filled.'
    ],
    answerKey: [
      { taskId: 'q1', answer: 'Answer: 14. Solution: 3/8 × 48 = 18; 1/3 × 48 = 16; 18 + 16 = 34; 48 − 34 = 14. Parent note: дроби от целого, потом остаток. / Grade 5–6: fractions of a whole + remainder.' },
      { taskId: 'q2', answer: 'Answer: 4.5 минуты. Solution: 0.5 + 1.75 + 2.25 = 4.5. Parent note: складываем десятичные по столбику; можно сгруппировать 1.75 + 2.25 = 4, потом + 0.5. / Grade 5–6: decimal addition.' },
      { taskId: 'q3', answer: 'Answer: 15. Solution: 3x + 12 = 57; 3x = 45; x = 15. Parent note: линейное уравнение; обозначаем неизвестное количество фраз в наборе как x. / Grade 5–6: linear equation.' },
      { taskId: 'q4', answer: 'Answer: 96. Solution: 65% of 120 = 0.65 × 120 = 78; 78 + 18 = 96. Parent note: процент от числа, потом прибавляем новых учеников. / Grade 5–6: percent of a number.' },
      { taskId: 'q5', answer: 'Answer: подарок — звонкая «д» (проверка: подарочек); машина — глухая «ш» (машинка); след — звонкая «д» (следы); гладко — звонкая «д» (гладок); нельзя — нет пары, запомнить; правило — звонкая «в» (правил). Solution: парные согласные в корне проверяем гласной после согласной. Parent note: правило — поставить гласную после согласной (подарочек/следы/гладок), и звук станет ясно слышен. / Rule: vowel reveals the consonant.' },
      { taskId: 'q6', answer: 'Answer: «Сначала проверь с родителем. Если просьба кажется странной, отойди и найди безопасного взрослого.» Solution: проверь точку в конце, запятую после «странной», заглавные буквы. Parent note: ≤ 2 ошибок — нормально. / Mini-dictation: ≤ 2 errors acceptable.' },
      { taskId: 'q_corr', answer: 'Answer: «Сначала проверь с родителем. Если просьба кажется странной, отойди и найди безопасного взрослого.» Solution: снечала→Сначала (заглавная + проверка: начал); родитилим→родителем (безударная «е», проверка: родители); еслi→Если (русская «и» + заглавная); страной→странной (две «н»); аатойди→отойди (приставка «от», проверка: отойти); безапасного→безопасного (опасный). Parent note: 6 ошибок в коротком тексте — для возраста засчитывай ≥ 5/6 исправлений. / Acceptance: ≥ 5/6 corrections.' },
      { taskId: 'q7', answer: 'Answer: 3-пунктовый план + 3–5 предложений. Solution: пример плана — 1) взрослый не должен звать ребёнка уйти без проверки; 2) подарок / поездка / секрет от родителей — это «жёлтый» или «красный»; 3) можно сказать нет, отойти и найти безопасного взрослого. Parent note: главное — что фраза «проверить с родителем» легитимна и не грубость. / 3-point plan; legitimacy of "check first".' },
      { taskId: 'q_obs', answer: 'Answer: Зелёный = одобрено родителем (например, идти с учителем). Жёлтый = надо проверить сначала (друг зовёт без родителя). Красный = стоп и сразу к взрослому (незнакомец зовёт в машину, «секрет от родителей»). Solution: «секрет от родителей» автоматически делает любую просьбу красной. Главное — что просит взрослый, а не как он выглядит. Вывод: «Судим по просьбе, а не по внешности». Parent note: принимай любой вывод, который ставит поведение и просьбу выше внешности. / Behaviour over appearance.' },
      { taskId: 'q8', answer: 'Answer: Зелёный — родитель сказал идти с учителем; учитель просит идти в офис школы. Жёлтый (проверить сначала) — друг зовёт на площадку без родителя; взрослый просит помочь найти животное. Красный (стоп и к взрослому) — незнакомец зовёт в машину; подарок без родителя; «секрет от родителей»; сообщение онлайн просит личные данные. Solution: правило цвета задаётся просьбой и доверием родителя, не одеждой/возрастом. Parent note: проговорите вслух 1–2 спорные карточки. / Sortings.' },
      { taskId: 'q9', answer: 'Answer: открытый ответ, 3–5 предложений. Solution: пример — «Моя уверенная фраза: «Мне нужно проверить с родителем». На английском: "I need to check with my parent". Я скажу её спокойно и отойду к безопасному взрослому.» Parent note: критерии — короткая русская фраза, имя взрослого и одна английская фраза. / Open answer with required parts.' }
    ],
    spellingCheck:
      'Принимать, если правильно подобраны проверочные хотя бы для 3 из 5 парных согласных и мини-диктант с не более чем 2 ошибками. / Accept ≥ 3/5 paired consonants and ≤ 2 mistakes in dictation.',
    readingCheck:
      'План — 3 пункта; пересказ по-русски без чтения с листа. / 3-point plan; retell in Russian without reading.',
    practicalCheck:
      'Лестница действий из 5 шагов записана в правильном порядке; карточки разложены логично; есть фраза на русском и одна на английском. / 5-step ladder in correct order; cards sorted logically; RU + EN phrase present.',
    rolePlayCheck:
      'Родитель проигрывает 1–2 короткие сценки. Ребёнок отвечает уверенно: «Мне нужно проверить с родителем» / «I need to check with my parent» — без длинного объяснения. / Parent role-plays 1–2 short scenes; child responds firmly with the phrase, no long explanation.',
    discussionPrompts: [
      'Что такое «зелёный», «жёлтый», «красный» в нашем правиле? / What does "green / yellow / red" mean in our rule?',
      'Что важнее в странной ситуации — быть вежливым или быть в безопасности? / What matters more — being polite or being safe?',
      'Почему «секрет от родителей» — это сигнал тревоги? / Why is "secret from parents" a warning?',
      'Что ты сделаешь, если незнакомый взрослый предложит подарок или поездку? / What if an unknown adult offers a gift or a ride?'
    ],
    ifEasy:
      'Усложни: попроси придумать ещё 3 ситуации и присвоить им цвет (зелёный/жёлтый/красный) с обоснованием. / Add 3 more situations and assign colours with reasoning.',
    ifDifficult:
      'Возьми 3 простых сценки (родитель/учитель/незнакомец) и проиграйте каждую по 30 секунд. Достаточно одной короткой фразы. / Use 3 simple scenes (parent/teacher/stranger) and role-play each for 30 s. One short phrase is enough.',
    commonMistakes: [
      'Ребёнок хочет быть вежливым вместо того, чтобы быть в безопасности. Подсказка: «В странной ситуации можно сказать твёрдо.» / Child prioritises politeness — remind: firm is okay in strange situations.',
      'Ребёнок думает, что любой знакомый-выглядящий взрослый — безопасный. Уточни: судим по просьбе и поведению, а не по внешности. / Child judges by appearance — clarify: judge by request/behaviour.'
    ],
    parentNote:
      'Тон спокойный. Помоги ребёнку увидеть, что уверенная фраза — это не грубость, а защита. / Calm tone. Help the child see that a firm phrase is protection, not rudeness.',
    tokenReward:
      'После проверки можно начислить бонусные нимы через Parent Room. Нимы — это призовые токены курса, а не оплата. / After checking the work, the parent may add bonus nims through Parent Room. Nims are course prize tokens, not payment.'
  },
  reward: {
    unit: 'nim',
    unitName: 'ним',
    base: 3,
    max: 5,
    label: 'Награда за миссию',
    display: '3 нима',
    bonuses: [
      { id: 'check-first-rule', label: 'Бонус за правильное правило «проверить сначала»', amount: 1 },
      { id: 'safety-phrase', label: 'Бонус за уверенную фразу безопасности', amount: 1 }
    ]
  },
  completionRequirements: {
    requiredTaskIds: ['q1', 'q5', 'q7', 'q8', 'q9'],
    allowNotebookCompletion: true
  },
  nextLessonId: 'max-week-2-day-3'
};

export default day2;
